<template>
  <div class="configManageDriveAdminVue">
    <div class="col-md-10 col-sm-9 u-pad-all-25 c-common-box-shadow u-bg-color-fff">
        <!-- Manage Drive Admins -->
        <div class="manage-powerusers">

            <h3 class="u-cmn-botmargin">Manage Drive Admins <span class="c-common-btn--inverse-icon-orange"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></h3>

            <div class="row">
                <div class="col-md-6">
                    <div class="o-manageusers-checkbox c-margin-bottom-10">
                        <div class="manageusers-checkbox-head clearfix">
                            <div class="row">
                                <div class="col-md-6">
                                <h4>Active Drive Admins:</h4>
                                <div class="o-subtitleHeading">
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            <input type="checkbox" name="o4" v-model="selectType" @change="selectAll()">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                    <label class="o-blue-regular-text">Select All:</label>
                                </div>
                            </div>
                            <div class="col-md-6 text-right">
                                <a href="javascript: void(0)" @click="removeAdmins()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a>
                            </div>
                            </div>
                        </div>
                        <div class="manageusers-checkbox-body clearfix">
                            <div class="manageusers-checkbox-body-inner">
                                <div v-for="admin in driveAdminsList" :key="admin.id" class="col-sm-6 o-powerUser-list">
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            {{ admin.first_name + " " + admin.last_name }}
                                            <input type="checkbox" name="o4" :value="admin.id" v-model="selectedAdmins">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </div>
                                <div v-if="driveAdminsList.length === 0" class="col-sm-12" style="padding: 10px; color: #999;">
                                    No Drive Admins configured yet.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="addnewpoweruser">
                      <h4>Add New Drive Admin:</h4>
                        <div class="o-cutsomSelect o-cutsomSelect--poweruser o-multiselect-drop">
                            <el-select
                                v-model="selectedEmployees"
                                filterable
                                remote
                                reserve-keyword
                                multiple
                                collapse-tags
                                style="width: 100%;"
                                placeholder="Select">
                                <el-option
                                  v-for="emp in eligibleList"
                                  :key="emp.id"
                                  :label="emp.first_name + ' ' + emp.last_name"
                                  :value="emp.id">
                                </el-option>
                              </el-select>
                        </div>
                        <div class="clearfix"></div>
                        <a href="javascript: void(0)" @click="promoteAdmins()" class="c-solid-btn c-solid-btn--green">Promote</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Manage Drive Admins -->
    </div>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import service from '../../services.js';
    export default {
        data() {
            return {
                driveAdminsList: [],
                eligibleList: [],
                selectedEmployees: [],
                selectedAdmins: [],
                selectType: 0
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            promoteAdmins() {
                if (this.selectedEmployees.length != 0) {
                    service.post('drive/managers', {
                            'employee_ids': JSON.stringify(this.selectedEmployees)
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.$notify({
                                title: 'Success',
                                message: 'Drive Admin(s) promoted successfully',
                                type: 'success'
                            });
                            this.getInitialData();
                            this.selectedEmployees = [];
                        }).catch((err) => {
                            var msg = (err.response && err.response.data && err.response.data.status_message) ? err.response.data.status_message : 'Failed to promote Drive Admin';
                            this.$notify({
                                title: 'Error',
                                message: msg,
                                type: 'error'
                            });
                            console.log(err);
                        });
                }
            },
            removeAdmins() {
                if (this.selectedAdmins.length != 0) {
                    service.post('drive/managers/remove', {
                            'employee_ids': JSON.stringify(this.selectedAdmins)
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.$notify({
                                title: 'Success',
                                message: 'Drive Admin(s) removed successfully',
                                type: 'success'
                            });
                            this.getInitialData();
                            this.selectedAdmins = [];
                            this.selectType = 0;
                        }).catch((err) => {
                            var msg = (err.response && err.response.data && err.response.data.status_message) ? err.response.data.status_message : 'Failed to remove Drive Admin';
                            this.$notify({
                                title: 'Error',
                                message: msg,
                                type: 'error'
                            });
                            console.log(err);
                        });
                }
            },
            getInitialData() {
                service.get('drive/managers', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.driveAdminsList = res.data.result || [];
                    }).catch((err) => {
                        console.log(err);
                    });

                service.get('drive/managers/eligible', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.eligibleList = res.data.result || [];
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            selectAll() {
                this.selectedAdmins = [];
                if (this.selectType == true) {
                    for (var i = 0; i < this.driveAdminsList.length; i++) {
                        this.selectedAdmins.push(this.driveAdminsList[i].id);
                    }
                }
            }
        },
        created() {
            this.getInitialData();
        }
    }
</script>
<style scoped>
</style>
